module.exports = __webpack_public_path__ + "img/base_hebergements_hotel.d9c7c4b9.svg";